(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sizing-calculator"] && !Shopify.designMode) return;
  try {
    
  class SizingCalculator extends HTMLElement {
    connectedCallback() {
      this.circuitRadios = this.querySelectorAll('[data-circuit-option]');
      this.panels = this.querySelectorAll('[data-circuit-panel]');
      this.form = this.querySelector('.sizing-calculator__form');
      this.wattsInput = this.querySelector('[data-calc-watts]');
      this.voltsInput = this.querySelector('[data-calc-volts]');
      this.result = this.querySelector('[data-calc-result]');
      this.ampsEl = this.querySelector('[data-calc-amps]');
      this.headingEl = this.querySelector('[data-calc-heading]');
      this.messageEl = this.querySelector('[data-calc-message]');
      this.ctaEl = this.querySelector('[data-calc-cta]');
      this.threshold = parseFloat(this.dataset.threshold) || 40;

      this.circuitRadios.forEach((radio) => {
        radio.addEventListener('change', () => this.showPanel(radio.dataset.circuitOption));
      });

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.calculate();
      });
    }

    showPanel(option) {
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.circuitPanel !== option;
      });
      this.result.hidden = true;
    }

    calculate() {
      const watts = parseFloat(this.wattsInput.value);
      const volts = parseFloat(this.voltsInput.value);

      if (!watts || watts <= 0 || !volts) {
        return;
      }

      const amps = watts / volts;
      const withinRange = amps <= this.threshold;

      this.ampsEl.textContent = `That works out to roughly ${amps.toFixed(1)}A continuous.`;
      this.result.dataset.calcState = withinRange ? 'recommended' : 'fallback';

      if (withinRange) {
        this.headingEl.textContent = this.dataset.recommendedHeading;
        this.messageEl.textContent = this.dataset.recommendedMessage;
        this.ctaEl.href = this.dataset.recommendedLink;
        this.ctaEl.textContent = this.dataset.recommendedLabel;
      } else {
        this.headingEl.textContent = this.dataset.fallbackHeading;
        this.messageEl.textContent = this.dataset.fallbackMessage;
        this.ctaEl.href = this.dataset.fallbackLink;
        this.ctaEl.textContent = this.dataset.fallbackLabel;
      }

      this.result.hidden = false;
    }
  }

  customElements.define('sizing-calculator', SizingCalculator);

  } catch(e) { console.error(e); }
})();
})();
